// extracted by mini-css-extract-plugin
export var canvas = "Drawing-module--canvas--82WZc";